import { render, staticRenderFns } from "./AccountSingleFund.html?vue&type=template&id=390cf19a&scoped=true&"
import script from "./AccountSingleFund.ts?vue&type=script&lang=ts&"
export * from "./AccountSingleFund.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_funds.scss?vue&type=style&index=0&id=390cf19a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390cf19a",
  null
  
)

export default component.exports